import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import routes from './routes.js';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';

import SortControl from '@/components/overrides/vue-tables-2/SortControl.vue';
import Notifications from 'vue-notification';
import Vuelidate from 'vuelidate';
import VueCookies from 'vue-cookies';

import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';

// import createServer from './api/mock';

import { ServerTable } from 'vue-tables-2';
import { api } from '@/admin/api.js';

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    Vue,
    dsn:
      'https://a3f5662c75bf46c0b2ece1d71fb4d557@o403799.ingest.sentry.io/5795686',
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
    environment: process.env.NODE_ENV,
  });
}

// if (window.Cypress) {
//   let otherDomains = [];
//   let methods = ['get', 'put', 'patch', 'post', 'delete'];

//   createServer({
//     environment: 'test',
//     routes() {
//       for (const domain of ['/', ...otherDomains]) {
//         for (const method of methods) {
//           this[method](`${domain}*`, async (schema, request) => {
//             let [status, headers, body] = await window.handleFromCypress(
//               request
//             );
//             return new Response(status, headers, body);
//           });
//         }
//       }

//       // If your central server has any calls to passthrough(), you'll need to duplicate them here
//       // this.passthrough('https://analytics.google.com')
//     },
//   });
// }

Vue.use(VueCookies);
Vue.$cookies.config('30d');

Vue.use(Vuelidate);
Vue.use(Notifications);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueRouter);
Vue.use(
  ServerTable,
  {
    perPageValues: [],
    texts: {
      filter: '',
      filterPlaceholder: 'Buscar en la tabla',
      count:
        'Mostrando de {from} a {to} de un total de {count} resultados|{count} resultados|Un resultado',
      noResults: 'Sin resultados',
    },
    sortIcon: {
      is: 'arrow-down-up',
      base: '',
      up: 'arrow-up',
      down: 'arrow-down',
    },
    requestKeys: {
      query: 'search',
      limit: 'page_size',
      orderBy: 'sortBy',
      ascending: 'asc',
      page: 'page',
      byColumn: 'ordering',
    },
    requestFunction(data) {
      return api.get(this.url, { params: data }).catch(function (e) {
        this.dispatch('error', e);
      });
    },
    requestAdapter(data) {
      if (data.sortBy) {
        data['ordering'] = (data.asc ? '' : '-') + data.sortBy;
      }

      delete data['asc'];

      return data;
    },
    responseAdapter({ data }) {
      storeAdmin.setOverlayShow(false);

      return {
        data: data.results,
        count: data.count,
      };
    },
    filterable: true,
  },
  false,
  'bootstrap4',
  {
    sortControl: SortControl,
  }
);

Vue.config.productionTip = false;

const router = new VueRouter({
  mode: 'history',
  routes, // short for `routes: routes`
});

import storeAdmin from '@/admin/store.js';

router.beforeEach((to, from, next) => {
  const loadOverlay = to.meta && to.meta.loadOverlay;
  if (loadOverlay && to.meta.authRequired) {
    storeAdmin.setOverlayShow(true);
  }

  if (to.meta.authRequired) {
    const authRequired = to.meta && to.meta.authRequired;
    if (!storeAdmin.state.auth.isAuthenticated && authRequired) {
      next({
        name: 'LoginScreen',
        params: { redirect: to.name, params: to.params },
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

new Vue({
  render: (h) => h(App),
  router,
}).$mount('#app');
